import { render, staticRenderFns } from "./calculations.vue?vue&type=template&id=0fc81764&scoped=true&"
import script from "./calculations.vue?vue&type=script&lang=js&"
export * from "./calculations.vue?vue&type=script&lang=js&"
import style0 from "./calculations.vue?vue&type=style&index=0&id=0fc81764&lang=scss&scoped=true&"
import style1 from "./calculations.vue?vue&type=style&index=1&id=0fc81764&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc81764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc81764')) {
      api.createRecord('0fc81764', component.options)
    } else {
      api.reload('0fc81764', component.options)
    }
    module.hot.accept("./calculations.vue?vue&type=template&id=0fc81764&scoped=true&", function () {
      api.rerender('0fc81764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/calculations.vue"
export default component.exports